<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <b-card bg-variant="danger" text-variant="white" class="text-center" style="padding-bottom: 0.5rem">
          <b-card-text style="font-size: 30px">Due Balance: ${{this.$store.getters.getDueBalance()}}</b-card-text>
        </b-card>
      </div>
      <div class="col-sm-6 billing">
        <b-card bg-variant="success" class="text-center">
          <b-card-text>
            <span style="font-size: 20px">Payments received by</span><br>
            <span><i>Zelle</i>: admin@brilom.com</span><br>
            <span><i>Cash App</i>: $BrilomGroup</span><br>
            <span>Note: Always include your company’s ID in the notes.</span>
          </b-card-text>
        </b-card>
      </div>
    </div>
    <CustomListingComponent ref="invoiceLists" class="bg-white"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </CustomListingComponent>
  </div>
</template>

<script>
import CustomListingComponent from '@/components/listing/CustomListingComponent'
import { INVOICE_COMPLETED, INVOICE_OPEN, SERVICE_INVOICE } from '../../constants'
import '@/mixins/generalMixin'
export default {
  name: 'Invoice',
  data () {
    return {
      companyList: [],
      selectedCompany: null,
      dueBalance: 0,
      columnConfig: [
        {
          columnCode: 'action',
          columnName: 'Status',
          align: 'left',
          custom: true,
          value: (item) => {
            return (item.Status === INVOICE_OPEN ? (<span class="badge badge-warning">Unpaid</span>) : (item.Status === INVOICE_COMPLETED ? <span class="badge badge-success">Paid</span> : <span class="badge badge-secondary">Pending</span>))
          }
        },
        {
          columnCode: 'number',
          columnName: 'Invoice Number',
          align: 'left',
          value: item => {
            return 'INV' + item.CompositeID
          }
        },
        {
          columnCode: 'type',
          columnName: 'Type',
          align: 'left',
          addClass: true,
          value: item => {
            return item.Type === SERVICE_INVOICE ? 'Service' : 'Membership'
          },
          className: item => {
            return item.Type === SERVICE_INVOICE ? 'badge badge-success' : 'badge badge-info'
          }
        },
        {
          columnCode: 'amount',
          columnName: 'Amount',
          align: 'left',
          value: item => {
            return item.Amount ? '$' + (item.Amount.toFixed(2)) : '$0.00'
          }
        },
        {
          columnCode: 'discount',
          columnName: 'Discount',
          align: 'left',
          value: item => {
            return item.Discount > 0 ? '$' + (item.Discount.toFixed(2)) : '$0.00'
          }
        },
        {
          columnCode: 'totalDueBalance',
          columnName: 'Total Due Balance',
          align: 'left',
          value: item => {
            return item.Amount > 0 ? '$' + ((item.Amount - item.Discount).toFixed(2)) : '$0.00'
          }
        },
        {
          columnCode: 'startDate',
          columnName: 'Start Date',
          align: 'left',
          value: item => {
            return this.dateFormat(item.StartDate)
          }
        },
        {
          columnCode: 'enddate',
          columnName: 'End Date',
          align: 'left',
          value: item => {
            return this.dateFormat(item.EndDate)
          }
        },
        {
          columnCode: 'dueDate',
          columnName: 'Due Date',
          align: 'left',
          value: item => {
            return this.dateFormat(item.DueDate)
          }
        },
        {
          columnCode: 'paidDate',
          columnName: 'Paid Date',
          align: 'left',
          value: item => {
            return item.Status === INVOICE_COMPLETED ? this.dateFormat(item.CompletedDate) : 'N/A'
          }
        },
        {
          columnCode: 'detail',
          columnName: 'Actions',
          align: 'left',
          custom: true,
          value: item => {
            let download
            if (item.Type === SERVICE_INVOICE) {
              download = <b-button onClick={() => this.onClickDownload(item.CompositeID)}>Download</b-button>
            } else {
              download = 'N/A'
            }
            return (
              <div class="action-buttons">
                {download}
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      if (this.selectedCompany) {
        payload.params.company_id = this.selectedCompany.value
      }
      return this.axios.post('api/invoices', payload.params)
    },
    onClickDownload (ID) {
      const url = '/api/invoice/download/' + ID
      window.open(url, '_blank')
    }
  },
  components: {
    CustomListingComponent
  }
}
</script>

<style scoped>
.fa-exclamation-circle {
  color: #d69405;
  font-size: 20px;
}
.fa-check-circle {
  color: green;
  font-size: 20px;
}
.fa-clock {
  color: #a7040b;
  font-size: 20px;
}

.fa-circle {
  font-size: 20px;
}
.action-buttons .btn{
  margin-right: 8px
}

.billing .card-body {
  margin: 0;
  padding: 0;
}
</style>
